/* eslint-disable */
'use strict';
import Vue from 'vue';
import {
  apiCall
} from '@/utils/api';
import { URL } from '../../utils/api';
import {removeCookie} from '@/utils/cookie';

const state = {
  status: null,
  error: null,
  isLogged: false,
  userData: null,
  userGroupType: null,
  amis:'',
};

const getters = {
  isLogged: (state) => {
    return state.isLogged;
  },
  amis:(state)=>{
    return state.amis
  },
  status: (state) => {
    return state.status;
  },
  error: (state) => {
    return state.error;
  },
  userData: (state) => {
    return state.userData;
  },
  user: (state) => {
    return state.userData ? state.userData : null;
  },
  userGroupTypes: (state) => {
    return state.userData ? state.userData.steps : null;
  },
  userGroupType: (state) => {
    return state.userGroupType;
  },
  currentStep:(state)=>{
    return state.userGroupType ? state.userData.steps.find(item=>item.id==state.userGroupType) : null;
  }
};

const actions = {
  async checkLogin({
    state,
    commit,
    dispatch
  }) {
    return new Promise(async (resolve, reject) => {
      let udat=sessionStorage.getItem('udat');
      let userData = udat ? decodeURIComponent(escape(atob(udat))) : null;
      let userGroupType = sessionStorage.getItem('userGroupType');
      if (userData && Vue.cookie.get('ASAN-APPEAL-TOKEN')) {
        let _userData=JSON.parse(userData)
        commit('setUserData', _userData);
        if(userGroupType || _userData.steps.length>0)
          commit('setUserGroupType', (userGroupType ? userGroupType : _userData.steps[0].id));
        commit('setIsLogged', true);
        resolve();
      } 
      else if (Vue.cookie.get('ASAN-APPEAL-TOKEN')) {
        await apiCall({
            url: URL[process.env.NODE_ENV].auth_api+'users/me',
            method: "post",
            params:{detailed:true}
          })
          .then((response) => {
            if (!response.data.error) {
              let userOb=response.data.data;
             userOb.photo=null;
              sessionStorage.setItem('udat', btoa(unescape(encodeURIComponent(JSON.stringify(userOb)))));
              if(userOb.steps.length>0)
                sessionStorage.setItem("userGroupType", userOb.steps[0].id);
              commit('setUserData', userOb);
              if(userOb.steps.length>0)
                commit('setUserGroupType', userOb.steps[0].id);
              commit('setIsLogged', true);
              commit('setStatus', 'success');
              resolve(response);
            } else {
              commit('setStatus', 'error');
              commit('setError', response.data.error);
              commit('logout');
              reject(response);
            }
          })
          .catch((error) => {
            commit('setStatus', 'error');
            commit('setError', error);
            commit('logout');
            removeCookie('ASAN-APPEAL-TOKEN');
            reject(error);
          });
      } else {
        commit('logout');
        reject();
      }
    });
  },
  async logout({
    commit
  }) {
    return new Promise(async (resolve, reject) => {
      //console.log('logout user module');
      commit('setStatus', 'loading');
      commit('setIsLogged', false);
      commit('logout');
      resolve();
    });
  },
  async setUserGroupType({
    commit
  }, data) {
    return new Promise(async (resolve, reject) => {
      commit("setUserGroupType", data);
      sessionStorage.setItem("userGroupType", data);
      resolve();
    });
  },

  async setamis({
    commit
  }, data) {
    return new Promise(async (resolve, reject) => {
      commit("setamis", data);
     
    });
  },
};

const mutations = {
  setStatus(state, payload) {
    state.status = payload;
  },
  setUserData(state, payload) {
    state.userData = payload;
  },
  setUserGroupType(state, payload) {
    state.userGroupType = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setIsLogged(state, payload) {
    state.isLogged = payload;
  },
  setamis(state,payload){
    state.amis=payload
  },
  logout(state) {
    state.isLogged = false;
    state.userData = null;
    sessionStorage.removeItem("cmit");
    localStorage.removeItem("amenu");
    localStorage.removeItem("omis");
    Vue.cookie.delete("TOKEN");
    sessionStorage.removeItem("userGroupType");
    sessionStorage.removeItem("udat");
    state.error = null;
    state.status = null;
  },
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};
